import { z } from 'zod';

export const paymentsParams = z.object({
  teamUuid: z.string(),
  appUuid: z.string(),
});
